<div class="p-d-flex p-flex-column p-flex-md-row kreiranje-prijemnice-form">
  <div class="p-d-flex pdf-col">
    <div class="pdf-data"
         *ngIf="pdfFileUrl; else loadingPdfSkeleton"
    >
      <ng2-pdfjs-viewer
        [pdfSrc]="pdfFileUrl"
        [showSpinner]="false"
        locale="sr-Latn"
        [openFile]="false"
        [download]="true"
        [viewBookmark]="false"
        cursor="hand"
      >
      </ng2-pdfjs-viewer>
    </div>
  </div>
  <div class="p-d-flex form-col">
    <form *ngIf="form" [formGroup]="form" class="pdf-form">
    <kodit-card-container>
      <div card-body class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
        <kodit-field
          fieldLabel="Generiši broj po pravilu"
          fieldLabelFor="pravilo-za-broj"
          class="flex-1"
        >
          <kodit-pravilo-za-broj-racuna-dropdown
            [formCtrl]="form.controls.praviloZaBrojId!"
            formCtrlId="pravilo-za-broj"
            [tipRacuna]="tipRacuna"
          >
          </kodit-pravilo-za-broj-racuna-dropdown>
        </kodit-field>

        <div class="p-field flex-1">
          <label for="magacin-dropdown" kodit-form-label>Izaberite magacin:</label>
            <kodit-magacin-dropdown
              [magacinCtrl]="form.controls.magacinId!"
            ></kodit-magacin-dropdown>
        </div>
      </div>
    </kodit-card-container>
      <!-- STAVKE -->
      <kodit-card-container cardClass="p-mt-3">
        <div card-title>Stavke</div>
        <div card-subtitle>Mapirajte artikle sa otpremnice sa artiklima u našem sistemu</div>
        <div card-right-side class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid card-right-force-width">
            <div class="flex-1">
              <button
                pButton
                type="button"
                icon="fa-solid fa-check"
                class="p-button-text w-full no-wrap-btn"
                pTooltip="Prihvati pristiglu količinu u celosti za sve stavke"
                label="Prihvati u celosti"
                (click)="prihvatiUCelosti()"
              ></button>
            </div>
            <div class="flex-1">
              <button
                pButton
                type="button"
                icon="fa-regular fa-xmark"
                class="p-button-text p-button-danger"
                pTooltip="Odbij pristiglu količinu u celosti za sve stavke"
                label="Odbij u celosti"
                (click)="odbijUCelosti()"
              ></button>
            </div>
        </div>
        <div card-body title="Stavke racuna">
          <kodit-stavke-eprijemnice-table
            [form]="form"
          >
          </kodit-stavke-eprijemnice-table>
        </div>
      </kodit-card-container>

      <kodit-card-container cardClass="p-mt-3">
        <div card-title>Napomena prijemnice</div>
          <div card-body>
            <p-editor
              id="napomena-isporuke"
              [formControl]="form.controls.napomena!"
              [style]="{ height: '150px' }"
            >
              <ng-template pTemplate="header">
                  <span class="ql-formats">
                    <button
                      type="button"
                      class="ql-bold"
                      aria-label="Bold"
                    ></button>
                    <button
                      type="button"
                      class="ql-italic"
                      aria-label="Italic"
                    ></button>
                  </span>
              </ng-template>
            </p-editor>
          </div>
      </kodit-card-container>
    </form>
  </div>
</div>

<ng-template #loadingPdfSkeleton>
  <div class="loading-card pdf-data">
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
  </div>
</ng-template>
